import { CustomerType, SessionContextInput } from 'gql/__generated/vp-apollo';
import { Button, Container, Flex, mediaQueries, RadioButton, useMediaQuery } from '@dtpk-cc/components';
import { ControlledRadioButtonGroup } from 'components/form/ControlledRadioButtonGroup';
import { useCustomerTypeSelectionFormContext } from '../hooks/useCustomerTypeSelectionForm';

type CustomerTypeSelectionFormProps = {
    submit: (sessionContext: Pick<SessionContextInput, 'customerType'>) => void;
};

export const CustomerTypeSelectionForm = ({ submit }: CustomerTypeSelectionFormProps) => {
    const breakpointS = useMediaQuery(mediaQueries.s);
    const { handleSubmit, lockSubmission } = useCustomerTypeSelectionFormContext();

    return (
        <form onSubmit={handleSubmit(submit)} autoComplete="off" noValidate>
            <Container variants={Container.Variant.paddedTop}>
                <ControlledRadioButtonGroup
                    variants={RadioButton.Group.Variant.block}
                    name="customerType"
                    render={({ field, fieldState }) => (
                        <>
                            <RadioButton.Legend>Bitte wählen Sie:</RadioButton.Legend>
                            <RadioButton
                                value={CustomerType.Existing}
                                isValid={!fieldState.error}
                                id="radio-customerType--existing"
                                data-test-action="select-radio-customerType--existing"
                                checked={field.value === CustomerType.Existing}
                                autoFocus
                            >
                                Telekom Vertragswechsel
                            </RadioButton>
                            <RadioButton
                                value={CustomerType.New}
                                isValid={!fieldState.error}
                                id="radio-customerType--new"
                                data-test-action="select-radio-customerType--new"
                                checked={field.value === CustomerType.New}
                            >
                                Neuvertrag
                            </RadioButton>
                            <RadioButton
                                value={CustomerType.ProviderChange}
                                isValid={!fieldState.error}
                                id="radio-customerType--provider-change"
                                data-test-action="select-radio-customerType--provider-change"
                                checked={field.value === CustomerType.ProviderChange}
                            >
                                Wechsel von einem anderen Anbieter
                            </RadioButton>
                            {!!fieldState.error && <p>Bitte treffen Sie eine Auswahl</p>}
                        </>
                    )}
                />
            </Container>
            <Container variants={Container.Variant.paddedTop}>
                <Flex justifyContent={breakpointS ? 'center' : 'end'}>
                    <Button type="submit" disabled={lockSubmission} hasMinWidth>
                        {lockSubmission ? 'Bitte warten...' : 'Weiter'}
                    </Button>
                </Flex>
            </Container>
        </form>
    );
};
